export enum ApplicationSentBy {
  Participant = 866190400,
  Csn = 866190300,
  Employee = 866190200,
  CompanyRepresentative = 866190100,
  UnionRepresentative = 866190000,
  JointParties = 866190500,
  Coach = 866190600,
  InternalTSL = 866190700,
}

export const ApplicationSentByText: {
  [key in ApplicationSentBy]: string;
} = {
  [ApplicationSentBy.Participant]: 'Deltagare',
  [ApplicationSentBy.Csn]: 'Csn',
  [ApplicationSentBy.Employee]: 'Anställd',
  [ApplicationSentBy.CompanyRepresentative]: 'Företagsrepresentant',
  [ApplicationSentBy.UnionRepresentative]: 'Facklig representant',
  [ApplicationSentBy.JointParties]: 'Partsgemensamt',
  [ApplicationSentBy.Coach]: 'Coach',
  [ApplicationSentBy.InternalTSL]: 'Internt TSL',
};
